/**
 * "Tekrar hoş geldiniz, Yasir".
 *
 * The name comes from `display_name` on the signed-in user - a real field the
 * account model requires at registration, already in memory from `/auth/me`,
 * so greeting someone costs no request.
 *
 * It is deliberately **not** derived from the email address. Turning
 * `yasir123@example.com` into "Yasir123" produces something that looks like a
 * name, is wrong about half the time, and is wrong in a way the user cannot
 * correct - `k.demir@`, `info@`, `hr-team@` all become confident nonsense.
 * When there is no name to show, the sentence simply ends: "Tekrar hoş
 * geldiniz." with no dangling comma and no guess.
 *
 * The accent is decoration on top of a sentence that already reads correctly
 * in plain text, so nothing is communicated by colour alone and a screen
 * reader hears one continuous phrase.
 */

import type { SessionUser } from "@/api/types";
import { useAuth } from "@/features/auth/AuthGate";
import "./home.css";

/**
 * The name to greet this user by, or null when there is none.
 *
 * Whitespace-only is treated as absent. The backend trims and requires a
 * display name today; this stays defensive because a greeting reading
 * "Tekrar hoş geldiniz,  " is worse than the generic one.
 */
export function greetingName(user: Pick<SessionUser, "display_name">): string | null {
  const name = user.display_name.trim();
  return name === "" ? null : name;
}

export function Greeting() {
  const { user } = useAuth();
  const name = greetingName(user);

  if (name === null) return <>Tekrar hoş geldiniz.</>;
  return (
    <>
      Tekrar hoş geldiniz, <span className="greeting__name">{name}</span>
    </>
  );
}
